module.exports = __webpack_public_path__ + "img/logo_kw.b8d381c2.png";